<template>
  <v-select
      v-model="model"
      :options="getAllActivities"
      v-bind="selectProps"
      label="label"
      :reduce="(activity) => activity.value"
      :placeholder="placeholder"
  />
</template>

<script>
export default {
  name: 'ActivitySelectBox',
  data(){
    return {
      getAllActivities: [
        {label: 'Login', value: "Login"},
        {label: 'Login failed', value: "Login-Failed"},
        {label: 'Renew password', value: "Renew Password"},
        {label: 'Create', value: "CREATE"},
        {label: 'Update', value: "UPDATE"},
        {label: 'Update partly', value: "UPDATE_PART"},
        {label: 'Delete', value: "DELETE"},
        {label: 'Duplicate', value: "DUPLICATE"},
        {label: 'Retrieve', value: "RETRIEVE"},
        {label: 'Get all', value: "Get All"},
        {label: 'Hierarchy', value: "Hierarchy"},
        {label: 'Monetary transaction', value: "MONETARY_TRANSACTION"},
        {label: 'KYC approve', value: "APPROVE"},
        {label: 'KYC decline', value: "DECLINE"},
        {label: 'Ticket status change', value: "STATUS_CHANGE"},
        {label: 'Ticket comment', value: "COMMENT"},
        {label: 'Affiliate registration', value: "AFFILIATE_REGISTRATION"},
      ]
    }
  },
  props: {
    value: {
      required: true,
    },
    selectProps:{
      default: () => ({})
    },
    disabled:{
      type: Boolean,
      default: () => false
    },
    clearable:{
      type: Boolean,
      default: () => false
    },
    multiple:{
      type: Boolean,
      default: () => false
    },
    placeholder:{
      type: String,
      default: () => ''
    }
  },
  computed:{
    model:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit('input',value);
      }
    },
    _selectProps(){
      let props = {...this.$props, ...this.selectProps}
      delete props.value
      delete props.options
      delete props.label
      delete props.reduce
      return props
    }
  }
}
</script>

<style scoped>

</style>
